import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class UserPasswordChangeController implements angular.IComponentController {
    controlChangePassword: any;

    static $inject = ['$scope', '$state'];

    constructor(private _$scope: angular.IScope,
        private _$state: angular.ui.IStateService) {
    }

    $onInit() {
        this._$scope.$watch(() => this.controlChangePassword, () => {
            if (this.controlChangePassword) {
                this.controlChangePassword.edit();
            }
        }, true);
    }

    save() {
        if (this.controlChangePassword) {
            this.controlChangePassword.save()
                .then(success => {
                    if (success === true) {
                        this._$state.go('workspace');
                    }
                });
        }
    }
}

export const wtUserPasswordChange: ComponentDefinition = {
    componentId: 'wtUserPasswordChange',
    controller: UserPasswordChangeController,
    template: require('./userPasswordChange.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};
